import { Component, Vue } from 'vue-property-decorator';

@Component
export default class JasperReports extends Vue {

  private downloadPdf(kind: string): void {
    const apiEndpoint = `/admin/shipping_destinations/previewPdf?kind=${kind}`;
    this.$apiClient.getRequest(apiEndpoint).then((response) => {
      const base64EncodedPdf: string = response.data;
      const byteCharacters = atob(base64EncodedPdf); 
      const byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
        const slice = byteCharacters.slice(offset, offset + 1024);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        byteArrays.push(new Uint8Array(byteNumbers));
      }
      const blob = new Blob(byteArrays, { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(blob);
      const newTab = window.open();
      if (newTab) {
        newTab.document.write(`
          <html>
            <body style="margin: 0; padding: 0;">
              <iframe src="${pdfUrl}" width="100%" height="100%" style="border: none;"></iframe>
            </body>
          </html>
        `);
        newTab.document.close();
      } else {
        console.error("Failed to open new tab.");
      }
    }).catch((error) => {
      console.error("Error fetching PDF:", error);
    });
  }
}